import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import {BehaviorSubject} from "rxjs";
import * as html2pdf from 'html2pdf.js'
import * as XLSX from 'xlsx';
import { IProduct } from '../models/product.model';
import { AuthService } from './auth.service';
import { NoteService } from './note.service';
import { User } from '../models/user.model';



@Injectable({
  providedIn: 'root'
})
export class SharedFonctionsService {

// 👧🔥🔥🔥🔥🔥 les notifications de favoris-------------------------------------------------------------

  // valeur de depart
  private stateMessageNow = new BehaviorSubject('1');
  // ici on observe la valeur donnée au depart
  stateMessage = this.stateMessageNow.asObservable();


  // ici on patarge la valeur  d'entre d'un composant A à un composant X et via cette methode on la modififie
  serviceGetValueServApp(message: string) {
    this.stateMessageNow.next(message);
    // console.log(message);
  }
// 👧🔥🔥🔥🔥🔥-------------------------------------------------------------



// 👧🔥🔥🔥🔥🔥-------------------------------------------------------------
  // Element pour show et hide le chatbox
  isModalActive = false;
  modal_t: any;
  button: any;

  //Element pour les files
  messageError?:string;
  validMsg=false;
  urlPhoto?:any;
  valeurPartagee: any;
  produitPartagee : IProduct;
  shopIdPartagee : number;
  shopNamePartagee : string;
  jobApplyidshared : number;
  jobApplynameshared : string
  sharedProdIdPartage ?: number;
  sharedProdNamePartage ?: string;
// 👧🔥🔥🔥🔥🔥-------------------------------------------------------------

    constructor( private noteService : NoteService,private authService: AuthService,private appLocation: Location ) {

   }

// 👧🔥🔥🔥🔥🔥-------------------------------------------------------------
// show and hide le chatbox
  showHideChatShared(){
    this.isModalActive = true;
    this.button=document.getElementById('button');
    this.button.classList.add('button');

    this.modal_t = document.getElementById('chat_modal');
    this.modal_t.classList.remove('hidden-chat');
    this.modal_t.classList.add('show-chat');
  }
  // input du composant chatbox
  getMessageShared(event) {

  }
  // 👧🔥🔥🔥🔥🔥-------------------------------------------------------------


  // 👧🔥🔥🔥🔥🔥-------------------------------------------------------------
  //calcuer la moyenne des notes attribués à un vendeur sur ses produits et services
  getMoyenneNotesSellerService( tab:any[]): any
  {
    let moyenneTotal: number;
    let valeurSomme: number=0;
    let effetifTotalNbNotes: number = 0;

      tab.forEach(element => {
          valeurSomme+=element.note
          effetifTotalNbNotes++;

      });

       return  moyenneTotal= valeurSomme/effetifTotalNbNotes;
  }

// 👧🔥🔥🔥🔥🔥-------------------------------------------------------------
// Obtenir l'utilisateur connecté
  getUserConnected (): any {
    let user : User;
    this.authService.getUSerBySessionId().subscribe((response: any) =>
    {
      user = response;
    }, (error: any) => {
      // console.log(error)
    });
    // console.log(user);

     return user
  };
  // -------------------------------------------------------------

  // 👧🔥🔥🔥🔥🔥-------------------------------------------------------------
  //Savoir si l'utilisateur est authentifié ou pas
  getAuthentificated():boolean{

    let userAuthentificate
    return this.authService.authenticated() ?  userAuthentificate = true : userAuthentificate = false;

  }
  // -------------------------------------------------------------

 // 👧🔥🔥🔥🔥🔥-------------------------------------------------------------
  //Fonction pour repartir a la page precedente
  handleback(){
    this.appLocation?.back();
  }

  // -------------------------------------------------------------


  //👧🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥--------------- select file input & read file

	selectFile(event: any, photoProfil)  {
    //Angular 11, for stricter type
    var mimeType = event.target.files[0].type;
    var sizeFile=event.target.files[0].size;
    let tabVal:any[] = [];
		if(!event.target.files[0] || event.target.files[0].length == 0) {
			this.messageError = 'Selectionner une photo';
		}
    // console.log("size!!!!!")
    // console.log(sizeFile)
    if(sizeFile<2000000){
      // console.log(mimeType);

      if (mimeType=="image/jpeg"||mimeType=="image/jpg"||mimeType=="image/png") {

        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (_event) => {
          this.messageError = "";
          this.validMsg = true;
          this.urlPhoto = reader.result;
          photoProfil = this.urlPhoto;
        }
      }
      else{

        // this.msg = "Ce type de fichier n'est pas pris en compte.";
        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (_event) => {
          this.messageError = "Ce type de fichier n'est pas pris en compte.";
          this.urlPhoto = reader.result;
          this.validMsg = false;
        }
      }
    }
    else{
      // this.msg = "la taille de l'image est trop grande";
      var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (_event) => {
          this.messageError = "La taille de l'image est trop grande";
          this.urlPhoto = reader.result;
          // photoProfil = this.urlPhoto;
          this.validMsg = false;
        }
    }
    return tabVal.push(this.messageError,this.urlPhoto,this.validMsg);

	}

// -----------------------------

//👧🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥--------------- export table into pdf file

exportToPdf(idElement, filename){
  var element = document.getElementById(idElement);
  var opt = {
    margin:       1,
    filename:     filename,
    image:        { type: 'jpeg', quality: 0.98 },
    html2canvas:  { scale: 2 },
    jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' }
  };
// New Promise-based usage:
  html2pdf().from(element).set(opt).save();
}

//👧🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥--------------- export table into excel file

exportexcel(idElement: any, fileName: string): void
    {
       /* table id is passed over here */
       let element = document.getElementById(idElement);
       const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

       /* generate workbook and add the worksheet */
       const wb: XLSX.WorkBook = XLSX.utils.book_new();
       XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

       /* save to file */
       XLSX.writeFile(wb, fileName);

    }


}
